/** @format */

import React, { PureComponent } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import SendLog from './utils/sendLog/index';
import dustLogConfig from './utils/sendLog/dust.config';
import Context from '@/components/Context';
import { connectContext } from '@/components/Context';

import { store, persistor } from './store';

import Header from './view/header/index';
import Main from './view/main/index';
import Footer from './view/footer/index';

import './App.css';

const sendDustLogInstance = new SendLog({}, dustLogConfig);

// 前端性能数据埋点
sendDustLogInstance.webPerformanceLog({
  performance: window.performance,
});

class App extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sendDustLogInstance: sendDustLogInstance,
      // notificationCount:1,
      visible: false,
      signUpVisible: false,
    };
  }

  // componentWillMount() {
  // 修改通知 count
  // store.dispatch({type:'CHANGE_COUNT',notificationCount:9});
  // }

  render() {
    return (
      <Context.Provider value={this.state}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <div className="App margin-bottom-20">
              {/* 头部 & 登录/注册 */}
              <Header />
              {/* 主体内容 */}
              <Main />
              {/* Footer */}
              <Footer />
            </div>
          </PersistGate>
        </Provider>
      </Context.Provider>
    );
  }
}

export default connectContext(App);
